module.exports = __webpack_public_path__ + "mobile/img/img_bg_student.ac5b80a3.png";